import React, { useEffect } from "react";

import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import Logo from "../components/common/Logo";
import Socials from "../components/common/Socials";

import "./styles/contact.css";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="page-content">
        <NavBar active="contact" />
        <div className="content-wrapper">
          <div className="contact-logo-container">
            <div className="contact-logo">
              <Logo width={40} />
            </div>
          </div>

          <div className="contact-container">
            <h1 className="title contact-title">Let's Get in Touch</h1>

            <p className="subtitle contact-subtitle">
              Feel free to get in touch! Whether you have a project idea, want
              to collaborate, or just want to say hello, I’d love to hear from
              you. Let's create something together.
            </p>
          </div>

          <div className="socials-container">
            <div className="contact-socials">
              <Socials />
            </div>
          </div>

          <div className="page-footer">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
